<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
        <Toolbar class="p-mb-4">
          <template #start>
            <div style="font-size: 1.4em; color: inherit">
              {{ $t('Card payments') }}
            </div>
<!--            <AddNewButton :label="$t('Add')" @click="addNewItem" />-->
          </template>
          <template #end>
            <SearchInput :disabled="dataTableIsLoading"
                         @change-processed-search-value="changeProcessedSearchValue"
                         v-model="searchData"
                         @show-spinner="isLoading = true"/>
          </template>
        </Toolbar>

        <!--  Desktop DataTable -->
        <Spinner v-if="isLoading"/>
<!--        <DesktopDataTable v-else-if="!isLoading && !$store.state.tabletLayout"-->
        <DesktopDataTable v-else
                          :dataTableIsLoading="dataTableIsLoading"
                          :showHeader="false"
                          :itemsArrayIsEmpty="itemsArrayIsEmpty"
                          :sort="sort"
                          :showSearchInput="false"
                          :actionButtonsCount="actionButtonsCount"
                          @sort-items="sortItems"
                          :headers="[
              {name: 'sales_invoice_id', title: $t('Invoice'), sortable: false},
              {name: 'order_id', title: $t('Order'), sortable: false},
              {name: 'customer', title: $t('Customer'), sortable: false},
              {name: 'date', title: $t('Date'), sortable: false},
              {name: 'payment_due', title: $t('paymentDueLabel'), sortable: false},
              {name: 'overdue', sortable: false},
              {name: 'state', title: $t('Status'), sortable: false},
              {name: 'sum', title: $t('Sum'), sortable: false},
              {name: 'created_at', title: $t('Created'), sortable: true},
          ]">
          <template v-slot:body>
            <tr v-for="(item, index) of items"
                :key="index"
                :class="{'updated-item': isItemUpdated(item.id)}">
              <td>
                <router-link v-if="item.sales_invoice && item.sales_invoice.number && item.sales_invoice.uid"
                             :to="{ path: '/sales-invoices', query: { show: item.sales_invoice.uid } }"
                             :target="settings.openAllLinksInSameTab ? '_self' : '_blank'"
                             rel="noopener"
                             draggable="false">
                  <span>{{ item.sales_invoice.number }}</span>
                </router-link>
                <router-link v-else-if="item.prepayment_invoice && item.prepayment_invoice.number && item.prepayment_invoice.uid"
                             :to="{ path: '/prepayment-invoices', query: { show: item.prepayment_invoice.uid } }"
                             :target="settings.openAllLinksInSameTab ? '_self' : '_blank'"
                             rel="noopener"
                             draggable="false">
                  <span>{{ item.prepayment_invoice.number }}</span>
                </router-link>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <router-link v-if="item.order && item.order.number && item.order.uid"
                             :to="{ path: `/orders/${item.order.uid}` }"
                             :target="settings.openAllLinksInSameTab ? '_self' : '_blank'"
                             rel="noopener"
                             draggable="false">
                  {{ item.order.number }}
                </router-link>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <CustomerData :user="item.customer"/>
              </td>
              <td>
                <span v-if="item.date">{{ formatDate(item.date) }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.sales_invoice" :class="{'warning-color': (countOverdueDays(item.sales_invoice.payment_due) < 0) && item.state !== 3}">{{ formatDay(item.sales_invoice.payment_due) }}</span>
                <span v-else-if="item.prepayment_invoice" :class="{'warning-color': (countOverdueDays(item.prepayment_invoice.payment_due) < 0) && item.state !== 3}">{{ formatDay(item.prepayment_invoice.payment_due) }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.sales_invoice && item.state !== 3" :class="{'warning-color': countOverdueDays(item.sales_invoice.payment_due) < 0}">{{ countOverdueDays(item.sales_invoice.payment_due) }}</span>
                <span v-if="item.prepayment_invoice && item.state !== 3" :class="{'warning-color': countOverdueDays(item.prepayment_invoice.payment_due) < 0}">{{ countOverdueDays(item.prepayment_invoice.payment_due) }}</span>
              </td>
              <td>
                <div  class="p-d-flex p-flex-wrap p-ai-center">
                  <div v-if="item.state" class="state-badge" :class="PaymentStates.find(state => state.num === item.state)?.color || ''">{{ PaymentStates.find(state => state.num === item.state)?.label[$i18n.locale] || '' }}</div>
                </div>
              </td>
              <td>
                <span>{{ formatCurrency(item.sum) }}</span>
              </td>

              <td class="table-date-line">
                <span v-if="item.created_at">
                  {{ formatBy(item.created_at, item.creator) }}
                </span>
                <i v-else class="ti-minus"/>
              </td>

              <td>
                <div class="actions">
<!--                  <AcceptButton :disabled="dataTableIsLoading"-->
<!--                                v-if="item.state === 1"-->
<!--                                v-tooltip.left="$t('Confirm')"-->
<!--                                @click="toggleConfirmed(item)"/>-->
<!--                  <RemoveButton :disabled="dataTableIsLoading"-->
<!--                                v-if="item.state === 3"-->
<!--                                v-tooltip.left="$t('Unconfirm')"-->
<!--                                @click="toggleConfirmed(item)"/>-->
                  <AcceptButton :disabled="dataTableIsLoading"
                                v-if="item.state === 1"
                                :tooltip="$t('Confirm')"
                                @click="toggleConfirmed(item)"/>

                  <RemoveButton :disabled="dataTableIsLoading"
                                v-if="item.state === 3"
                                :tooltip="$t('Unconfirm')"
                                @click="toggleConfirmed(item)"/>
                </div>
              </td>
            </tr>
          </template>
        </DesktopDataTable>

        <OwnPaginator v-show="!itemsArrayIsEmpty"
                      :rows="pagination.perPage"
                      :currentPage="pagination.currentPage - 1"
                      :totalPages="pagination.pageCount"
                      :totalRecords="pagination.totalCount"
                      :rowsPerPageOptions="[5,10,25,50,100,200]"
                      :pageLinkSize="11"/>

        <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>
			</div>

		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import PaymentStates from '@/translations/states/PaymentStates'
import formatMixins from '@/mixins/formatMixins'
import RemoveButton from '@/components/DataTable/RemoveButton'
import AcceptButton from '@/components/DataTable/AcceptButton'
import calculateMixins from '@/mixins/calculateMixins'
import httpMixins from "@/mixins/httpMixins";
import datatableMixins from "@/mixins/datatableMixins";
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import CustomerData from "@/components/CustomerData.vue";

export default {
  mixins: [ formatMixins, calculateMixins, httpMixins, datatableMixins, showErrorsMixins ],
  components: {RemoveButton, AcceptButton, CustomerData },
	data() {
		return {

      fieldsExpand: '' +
          'order, ' +
          'sales_invoice, ' +
          'prepayment_invoice, ' +
          'customer.customerStatus',
      apiLink: 'payment/card-payments',
      routePath: '/card-payments',
      sort: {
        column: 'id',
        direction: '-',
      },
      PaymentStates,
		}
	},
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    // if (!this.$store.state.user?.role) return
    this.getPageData()
	},
  methods: {
    getPageData() {
      // if (!this.userCanGetData || this.fetchInFlight) return
      this.getItems()
    },
    async toggleConfirmed(payment) {
      const paymentObj = {
        paymentId: payment.id,
        newState: payment.state === 1 ? 3 : 1,
      }
      try {
        const { status } = await httpClient.post('payment/toggle-confirmed', paymentObj)
        if (status === 200) {
          payment.state = paymentObj.newState
          this.updatedItem = payment.id
        }
      } catch(err) {
        this.showError(err)
      }
    },
    async getItems() {
      // console.log('try get items')
      if (!this.userCanGetData || this.fetchInFlight) return
      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      // console.log('get items')
      this.dataTableIsLoading = true
      const ctrl = this.setController?.('cardPayments')
      try {
        // console.log('get payments api')
        // const { status, data, headers } = await httpClient(`${this.apiLink}?page=${this.pagination.currentPage}&per-page=${this.pagination.perPage}&sort=${this.sort.direction + this.sort.column}&search=${this.searchData}&expand=${this.fieldsExpand}`)
        const { status, data, headers } = await httpClient(`${this.apiLink}`, {
          params: {
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.processedSearchValue ?? null,
            expand: this.fieldsExpand
          },
          signal: ctrl?.signal
        })
        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }
        } else {
          this.items = []
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.isLoading = false
        this.dataTableIsLoading = false
        if (this._abortors?.cardPayments === ctrl) {
          this._abortors.cardPayments = null
        }
      }
    }
	},
  computed: {
    actionButtonsCount() {
      return 1
    },
  }
}
</script>
<style scoped lang="scss">
td {
  height: 44px
}
</style>